export default __webpack_public_path__ + "static/silverXlDetail-7b91773f83e78ca8e5a58a9cecccb9a4.png";